/**
 * Returns the Curacao states list to populate the select item.
 */
export function gluky_addressfield_pr_states_list() {
let temporalStates = [];
const states =
{
    '00' : 'No Aplica',
    '01' : 'Distrito Senatorial de San Juan',
    '02' : 'Distrito Senatorial de Bayamón',
    '03' : 'Distrito Senatorial de Arecibo',
    '04' : 'Distrito Senatorial de Mayagüez',
    '05' : 'Distrito Senatorial de Ponce',
    '06' : 'Distrito Senatorial de Guayama',
    '07' : 'Distrito Senatorial de Humacao',
    '08' : 'Distrito Senatorial de Carolina',
}

Object.keys(states).map((res) => {
    temporalStates = [
    ...temporalStates,
    {
        name: states[res],
        code: res,
    },
    ];
});
return temporalStates;
}

/**
 * Returns the Curacao cities list by state code to populate the select item.
 *
 * @param $state_code
 *   The DANE state code
 * @return
 */
export function gluky_addressfield_pr_cities_list($state_code) {
let temporalCities = [];
const $data = {
    '00':{
        '00001' : 'No Aplica',
    },
    '01':{
        '01001' : 'San Juan (capital)',
    },
    '02':{
        '02002' : 'Bayamón',
        '02003' : 'Cataño',
        '02004' : 'Guaynabo',
        '02005' : 'Toa Baja',
        '02006' : 'Toa Alta',
    },
    '03':{
        '03007' : 'Arecibo',
        '03008' : 'Barceloneta',
        '03009' : 'Camuy',
        '03010' : 'Ciales',
        '03011' : 'Dorado',
        '03012' : 'Florida',
        '03013' : 'Hatillo',
        '03014' : 'Manatí',
        '03015' : 'Morovis',
        '03016' : 'Quebradillas',
        '03017' : 'Vega Alta',
        '03018' : 'Vega Baja',
    },
    '04':{
        '04019' : 'Aguada',
        '04020' : 'Aguadilla',
        '04021' : 'Añasco',
        '04022' : 'Cabo Rojo',
        '04023' : 'Hormigueros',
        '04024' : 'Isabela',
        '04025' : 'Las Marías',
        '04026' : 'Mayagüez',
        '04027' : 'Moca',
        '04028' : 'Rincón',
        '04029' : 'San Germán',
        '04030' : 'San Sebastián',
    },
    '05':{
        '05031' : 'Adjuntas',
        '05032' : 'Guánica',
        '05033' : 'Guayanilla',
        '05034' : 'Jayuya',
        '05035' : 'Lajas',
        '05036' : 'Lares',
        '05037' : 'Maricao',
        '05038' : 'Peñuelas',
        '05039' : 'Ponce',
        '05040' : 'Sabana Grande',
        '05041' : 'Utuado',
        '05042' : 'Yauco',
    },
    '06':{
        '06043' : 'Aibonito',
        '06044' : 'Barranquitas',
        '06045' : 'Cayey',
        '06046' : 'Cidra',
        '06047' : 'Coamo',
        '06048' : 'Comerío',
        '06049' : 'Corozal',
        '06050' : 'Guayama',
        '06051' : 'Juana Díaz',
        '06052' : 'Naranjito',
        '06053' : 'Orocovis',
        '06054' : 'Salinas',
        '06055' : 'Santa Isabel',
        '06056' : 'Villalba',
    },
    '07':{
        '07057' : 'Aguas Buenas',
        '07058' : 'Arroyo',
        '07059' : 'Caguas',
        '07060' : 'Gurabo',
        '07061' : 'Humacao',
        '07062' : 'Juncos',
        '07063' : 'Las Piedras',
        '07064' : 'Maunabo',
        '07065' : 'Naguabo',
        '07066' : 'Patillas',
        '07067' : 'San Lorenzo',
        '07068' : 'Yabucoa',
    },
    '08':{
        '08069' : 'Canóvanas',
        '08070' : 'Carolina',
        '08071' : 'Ceiba',
        '08072' : 'Culebra',
        '08073' : 'Fajardo',
        '08074' : 'Loíza',
        '08075' : 'Luquillo',
        '08076' : 'Río Grande',
        '08077' : 'Trujillo Alto',
        '08078' : 'Vieques',
    },
}
const cities = $data[$state_code] ? $data[$state_code] : null;
Object.keys(cities).map((citie) => {
    temporalCities = [
    ...temporalCities,
    {
        name: cities[citie],
        code: citie,
    },
    ];
});
return temporalCities;
}

